import { render } from "./LeaveBulkActionModal.vue?vue&type=template&id=7823af8c&scoped=true"
import script from "./LeaveBulkActionModal.vue?vue&type=script&lang=js"
export * from "./LeaveBulkActionModal.vue?vue&type=script&lang=js"

import "./LeaveBulkActionModal.vue?vue&type=style&index=0&id=7823af8c&scoped=true&lang=css"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7823af8c"]])

export default __exports__